const version='2.0.0'; const hash='7c03dfe'; export {version, hash};
